
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-body',
  templateUrl: './about-body.component.html',
  styleUrls: ['./about-body.component.scss']
})
export class AboutBodyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
 /*  reply_click(event: any)
  {
    const srcID = event.target.id;
    const x = srcID + '_Data';
      // alert(x);
      console.log(x);
  } */
}
